import get from 'lodash/get';

import {
  FILTERS_DISPLAY_VALUES
} from 'utils/constants/productDetailsPage';

import { countFiltersApplied } from 'utils/productFilters';

import {
  SELECT_PRODUCT,
  SELECT_ALT_PRODUCT,
  RECEIVE_SEARCH_ALTERNATIVES,
  RECEIVE_TOTAL_ALTERNATIVES,
  UPDATE_PRODUCT_QUANTITY,
  RECEIVE_MATERIALS,
  RECEIVE_COLORS,
  SELECT_PRODUCT_FILTER_OPTIONS,
  CLEAR_PRODUCT_FILTER,
  CLEAR_PRODUCT_FILTERS,
  UPDATE_FILTERS_APPLIED_COUNT,
  FILTER_SELECTED_PRODUCT,
  RESET,

  SET_VARIANTS_BY_ATTRIBUTE,
  SET_VARIANT_LOAD_STATUS,
  SET_VARIANT_PRODUCT_IDS,
  CLEAR_VARIANT_PRODUCT_IDS
} from './action-constants';

const initialProductState = {
  attributeVariants: null,
  selectedProduct: null,
  selectedProductAddOns: {},
  altProduct: null,
  alternatives: [],
  currentQuantity: 1,
  filterOptions: {
    color: [],
    material: [],
    brand: [],
    height: [],
    width: [],
    depth: [],
    price: [],
    category: [],
    purchased: [],
    designViewed: []
  },
  filterValues: {
    color: [],
    material: [],
    brand: [],
    height: [],
    width: [],
    depth: [],
    price: [],
    category: [],
    purchased: [],
    designViewed: []
  },
  filtersApplied: 0,
  displayedAlternatives: [],
  variantsLoading: 0,
  displayedVariants: []
};

export const pdpReducerKey = 'pdp';
export const pdpReducer = (state = initialProductState, action) => {
  let filterOptions;
  let filterValues;

  switch (action.type) {
    case SELECT_PRODUCT:
      return Object.assign({}, state, {
        selectedProduct: action.payload,
        altProduct: null,
        alternatives: state.alternatives ? Object.values(state.alternatives) : []
      });
    case SELECT_ALT_PRODUCT:
      return Object.assign({}, state, { altProduct: action.payload });
    case RECEIVE_TOTAL_ALTERNATIVES:
      return Object.assign({}, state, {
        totalAlternatives: action.payload.total
      });
    case UPDATE_PRODUCT_QUANTITY:
      return {
        ...state,
        currentQuantity: action.payload
      };
    case RECEIVE_MATERIALS:
      filterOptions = { ...state.filterOptions };
      filterOptions.material = action.payload.map(material => material.name.trim());
      return {
        ...state,
        filterOptions
      };
    case RECEIVE_COLORS:
      filterOptions = { ...state.filterOptions };
      filterOptions.color = action.payload.map(color => color.name.trim());
      return {
        ...state,
        filterOptions
      };
    case RECEIVE_SEARCH_ALTERNATIVES: {
      filterOptions = { ...state.filterOptions };
      const filters = get(action, 'payload.filters.filters') ||
        Object.keys(initialProductState.filterOptions);

      filters.forEach(filter => {
        if (FILTERS_DISPLAY_VALUES.includes(filter.filtername)) {
          filterOptions[filter.filtername.toLowerCase()] = filter.values;
        }
      });

      return {
        ...state,
        alternatives: action.payload.products,
        filterOptions
      };
    }
    case SELECT_PRODUCT_FILTER_OPTIONS:
      filterValues = { ...state.filterValues };
      filterValues[action.filter] = action.options;

      return {
        ...state,
        filterValues
      };
    case CLEAR_PRODUCT_FILTER:
      filterValues = { ...state.filterValues };
      filterValues[action.filter] = initialProductState.filterValues[action.filter];

      return {
        ...state,
        filterValues
      };
    case UPDATE_FILTERS_APPLIED_COUNT:
      const filtersApplied = countFiltersApplied(state.filterValues);
      return {
        ...state,
        filtersApplied
      };
    case CLEAR_PRODUCT_FILTERS:
      filterValues = { ...initialProductState.filterValues };

      return {
        ...state,
        filtersApplied: 0,
        filterValues
      };
    case FILTER_SELECTED_PRODUCT:
      const selectedProduct = state.altProduct || state.selectedProduct;
      const displayedAlternatives = state.alternatives.slice(0)
        .filter(product => (!selectedProduct || product.id() !== selectedProduct.id()));

      return {
        ...state,
        displayedAlternatives
      };
    case RESET:
      return initialProductState;
    case SET_VARIANTS_BY_ATTRIBUTE:
      return {
        ...state,
        attributeVariants: action.payload
      };
    case SET_VARIANT_LOAD_STATUS:
      return {
        ...state,
        variantsLoading: action.payload
      };
    case SET_VARIANT_PRODUCT_IDS:
      return {
        ...state,
        displayedVariants: action.payload
      };
    case CLEAR_VARIANT_PRODUCT_IDS:
      return {
        ...state,
        displayedVariants: []
      };
    default:
      return state;
  }
};
